import { UrlSearchState } from '@/types/state/search';
import { useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { getSearchUrlParameters } from './useSearch.helpers';

export type UseSearchParamsOutput = UrlSearchState & { page: number };

/**
 * Unified, memoized hook that reads search parameters from the URL.
 * Returns 1-based page numbers (consistent with URL and API).
 * Re-computes only when pathname or search string changes.
 */
export function useSearchParams({ ssrRenderedPage }: { ssrRenderedPage?: number }): UseSearchParamsOutput {
  const match = useRouteMatch();
  const location = useLocation();

  return useMemo(() => {
    const raw = getSearchUrlParameters({ match });
    return {
      ...raw,
      page: raw.page ?? ssrRenderedPage ?? 1,
    };
  }, [location.pathname, location.search, ssrRenderedPage]);
}
